exports = module.exports = require("../../../../../../web-hosted/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".SingleTaskPage__SingleTaskPageContainer__3NtZe {\n  width: 100%;\n  height: 100%;\n}\n\n.SingleTaskPage__TaskNotExistsContainer__1DM0c {\n  font-size: 18px;\n  width: 100%;\n  height: 50%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.SingleTaskPage__LeftPane__1Yfwq {\n  height: 100%;\n  /* margin-right: 10px; */\n  padding-right: 15px;\n}\n\n.SingleTaskPage__RightPane__3206I {\n  height: 100%;\n  width: 100%;\n  overflow: auto;\n}\n", ""]);

// exports
exports.locals = {
	"SingleTaskPageContainer": "SingleTaskPage__SingleTaskPageContainer__3NtZe",
	"TaskNotExistsContainer": "SingleTaskPage__TaskNotExistsContainer__1DM0c",
	"LeftPane": "SingleTaskPage__LeftPane__1Yfwq",
	"RightPane": "SingleTaskPage__RightPane__3206I"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../shared-components/src/containers/Mainpage/containers/SingleTaskPage/SingleTaskPage.css
// module id = 649
// module chunks = 0